import { render, staticRenderFns } from "./GroupSubscribers.vue?vue&type=template&id=bfe388d6&scoped=true"
import script from "./GroupSubscribers.vue?vue&type=script&lang=js"
export * from "./GroupSubscribers.vue?vue&type=script&lang=js"
import style0 from "./GroupSubscribers.vue?vue&type=style&index=0&id=bfe388d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe388d6",
  null
  
)

export default component.exports